import { Inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { catchError, switchMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

import { loadIsForeignUserInfo, loadUserInfo } from '../actions/userinfo.action';
import { of } from 'rxjs';
import { UserService } from 'src/app/shared/services/user.service';

@Injectable()
export class UserInfoEffects {
  private readonly baseRoute: string;
  constructor(
    private readonly actions$: Actions,
    private readonly http: HttpClient,
    private readonly userService: UserService,
    @Inject('BASE_URL') baseUrl: string
  ) {
    this.baseRoute = `${baseUrl}bff/`;
  }

  public loadUserInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadUserInfo), // Listen for the loadUserInfo action
      switchMap(() => {
        return this.userService.getUserDetails().pipe(
          switchMap((userInfo: any) => {
            return of(userInfo);
          }),
          // Handle errors and dispatch loadUserInfoFailure action
          catchError((_error) => {
            return of(null);
          })
        );
      })
    )
  );

  public loadIsForeignUserInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadIsForeignUserInfo),
      switchMap(() => {
        return this.userService.isForeignUser().pipe(
          switchMap((response: boolean | undefined | null) => {
            const isForeignUser = response ?? false;
            return of({ type: '[UserInfo] Load Is Foreign User Info Success', payload: isForeignUser });
          }),
          catchError((_error) => {
            return of({ type: '[UserInfo] Load Is Foreign User Info Failure', payload: null });
          })
        );
      })
    )
  );
}
